var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M10.4151 16.8476H13.2361V28.5806C13.2361 28.8123 13.4219 29 13.6512 29H18.4342C18.6635 29 18.8493 28.8123 18.8493 28.5806V16.9029H22.0923C22.3032 16.9029 22.4806 16.743 22.5046 16.5314L22.9972 12.2119C23.0107 12.093 22.9734 11.974 22.8947 11.8849C22.816 11.7956 22.7032 11.7446 22.5849 11.7446H18.8495V9.03686C18.8495 8.22063 19.2845 7.80673 20.1426 7.80673C20.2648 7.80673 22.5849 7.80673 22.5849 7.80673C22.8142 7.80673 23 7.61894 23 7.38737V3.42246C23 3.19081 22.8142 3.0031 22.5849 3.0031H19.219C19.1953 3.00193 19.1425 3 19.0648 3C18.4808 3 16.4508 3.11583 14.8473 4.60621C13.0705 6.2578 13.3175 8.23531 13.3765 8.57817V11.7445H10.4151C10.1858 11.7445 10 11.9322 10 12.1638V16.4282C10 16.6598 10.1858 16.8476 10.4151 16.8476Z","fill":"black"}));
}

Facebook.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none"};

module.exports = Facebook;

Facebook.default = Facebook;
